import React, { Component } from 'react';
import { Container, Row, Col, Card, CardBody, FormGroup, Label, Table, Button } from 'reactstrap';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import Select from 'react-select';
import { customersListAutocomplete } from '../../services/UserServices';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import Loading from '../../components/Loading';
import PaginationCustom from '../../components/pagination/Pagination';
import { logoutAction } from '../../redux/actions/UserActions';
import { downloadPdfsDeliveryLots } from '../../services/AuctionServices';
import './DeliverList.scss';
import { confirmAlert } from 'react-confirm-alert';
import { Constants } from '../../Constants';
import axios from 'axios';
import moment from 'moment';

const getDeliveriesList = async (data) => {
    try {
        const httpOptions = {
            headers: {
                'Authorization': data.token
            }
        };
        return await axios.post(`${Constants.BASE_URL}lots/getDeliveriesList`, data, httpOptions);
    } catch (error) {
        throw error;
    }

}

const postCancelDelivery = async (data) => {
    try {
        const httpOptions = {
            headers: {
                'Authorization': data.token
            }
        };
        return await axios.post(`${Constants.BASE_URL}lots/cancelDelivery`, data, httpOptions);
    } catch (error) {
        throw error;
    }
}

const DELIVERY = 1;
const INVOICE = 2;
const DELIVERY_AND_INVOICE = 3;
const CANCELED = 4;

class DeliverList extends Component {
    state = {
        breadcrumbItems: [
            { title: "Lotes", link: "#" },
            { title: 'Entregas', link: "#" }
        ],
        customers: [],
        userId: null,
        userSelect: { value: null, label: 'Seleccionar cliente a buscar' },
        loading: false,
        page: 1,
        pages: 0,
        deliveries: [],
    }

    componentDidMount = () => {
        toast.configure();
        this.fetchCustomers();
        this.fetchDeliveriesList();
    }

    fetchCustomers = async () => {
        try {
            let response = await customersListAutocomplete({
                token: this.props.sessionProps.account.token
            });
            await this.setState({
                customers: response.data.data.customers
            });
        } catch (error) {
            if (error !== undefined && error.response !== undefined && error.response.status === 401) {
                this.props.logout();
                this.props.history.push('/');
            }
            else {
                toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    pauseOnHover: false,
                    duration: 10000
                });
            }
        }
    }

    fetchDeliveriesList = async () => {
        await this.setState({ loading: true });
        try {
            let response = await getDeliveriesList({
                token: this.props.sessionProps.account.token,
                filterUserId: this.state.userId,
                page: this.state.page
            });
            await this.setState({
                deliveries: response.data.data.deliveries,
                pages: response.data.data.pages,
            });
            await this.setState({ loading: false });
        } catch (error) {
            await this.setState({ loading: false });
            let msg = 'Ocurrió un error al procesar la solicitud, reintentar.';
            if (error !== undefined && error.response !== undefined && error.response.data !== undefined) {
                msg = error.response.data.message;
            }
            toast.error(msg, {
                position: toast.POSITION.BOTTOM_CENTER,
                pauseOnHover: false,
                duration: 10000
            });
        }
    }

    _downloadPdfs = () => {
        confirmAlert({
            title: 'Descargar PDFs de compradores',
            message: `¿Esta seguro que desea descargar los PDFs de los compradores?`,
            buttons: [
                {
                    label: 'Cancelar'
                },
                {
                    label: 'Confirmar',
                    onClick: () => {
                        this.downloadPdfs()
                    }
                }
            ]
        });
    }

    downloadPdfs = async (lots, id_user) => {
        await this.setState({ loading: true });
        try {
            let response = await downloadPdfsDeliveryLots({
                usersId: [id_user],
                token: this.props.sessionProps.account.token,
                lots,
                showTotals: true
            });
            let link = document.createElement('a');
            link.href = response.data.data.url;
            link.download = `entrega_lotes_${id_user}.pdf`;
            link.target = "_blank";
            document.body.appendChild(link);
            link.click();
            await this.setState({ loading: false });
        } catch (error) {
            await this.setState({ loading: false });
            let msg = 'Ocurrió un error al procesar la solicitud, reintentar.';
            if (error !== undefined && error.response !== undefined && error.response.data !== undefined) {
                msg = error.response.data.message;
            }
            console.log({
                mag: 'tet',
                err: error.response
            }, 'error')
            toast.error(msg, {
                position: toast.POSITION.BOTTOM_CENTER,
                pauseOnHover: false,
                duration: 10000
            });
        }
    }

    _cancelDelivery = (id_delivery, action) => {
        let actionTmp = 'entrega'
        if (action === INVOICE) {
            actionTmp = 'facturación'
        }
        if (action === DELIVERY_AND_INVOICE) {
            actionTmp = 'entrega y facturación'
        }
        confirmAlert({
            title: 'Cancelar ' + actionTmp,
            message: `¿Esta seguro que desea cancelar la ${actionTmp}?`,
            buttons: [
                {
                    label: 'Cancelar'
                },
                {
                    label: 'Confirmar',
                    onClick: () => {
                        this.cancelDelivery(id_delivery, actionTmp)
                    }
                }
            ]
        });
    }

    cancelDelivery = async (id_delivery, actionTmp) => {
        await this.setState({ loading: true });
        try {
            let response = await postCancelDelivery({
                id: id_delivery,
                token: this.props.sessionProps.account.token
            });
            await this.setState({ loading: false });
            toast.success(`Se anuló la ${actionTmp}`, {
                position: toast.POSITION.BOTTOM_CENTER,
                pauseOnHover: false,
                duration: 10000
            });
            this.fetchDeliveriesList();
        } catch (error) {
            await this.setState({ loading: false });
            let msg = 'Ocurrió un error al procesar la solicitud, reintentar.';
            if (error !== undefined && error.response !== undefined && error.response.data !== undefined) {
                msg = error.response.data.message;
            }
            toast.error(msg, {
                position: toast.POSITION.BOTTOM_CENTER,
                pauseOnHover: false,
                duration: 10000
            });
        }
    }

    handleChange = (event) => {
        const { name, value } = event.target;
        this.setState({
            [name]: value
        });
    }

    changeCustomer = async (userId, e = null) => {
        await this.setState({
            userId: userId,
            userSelect: e !== null ? e : this.state.userSelect,
        });
        this.fetchDeliveriesList();
    }

    onPrev = async () => {
        await this.setState({ page: this.state.page - 1 });
        this.fetchDeliveriesList();
    }

    onNext = async () => {
        await this.setState({ page: this.state.page + 1 });
        this.fetchDeliveriesList();
    }

    onPage = async (page) => {
        await this.setState({ page: page });
        this.fetchDeliveriesList();
    }

    render() {
        return (
            <div id="deliver-list">
                <div className="page-content">
                    {this.state.loading && <Loading />}
                    <Container fluid>
                        <Breadcrumbs title="Listado de entregas" breadcrumbItems={this.state.breadcrumbItems} />
                        <Row>
                            <Col>
                                <Card>
                                    <CardBody>
                                        <FormGroup row>
                                            <Label className="col-md-2 col-form-label">Cliente</Label>
                                            <Col md={10}>
                                                <Select
                                                    options={this.state.customers.map(item => ({ value: item.id_user, label: item.name }))}
                                                    className="select2 select2-multiple"
                                                    placeholder="Seleccionar cliente a buscar"
                                                    onChange={(e) => this.changeCustomer(e.value, e)}
                                                    value={this.state.userSelect}
                                                />
                                            </Col>
                                        </FormGroup>

                                        <div className="table-responsive">
                                            <Table className="mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Fecha</th>
                                                        <th>Cliente</th>
                                                        <th>Lotes</th>
                                                        <th></th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.deliveries.map((item, index) =>
                                                            <tr>
                                                                <th scope="row">{moment(item.created_at).format('DD/MM/YYYY')}</th>
                                                                <td>{item.client_name}</td>
                                                                <td>
                                                                    {
                                                                        item.lots?.map((lot) => lot.id_lot).join(', ')
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {item.action === INVOICE || item.action === DELIVERY_AND_INVOICE ?
                                                                        <div className="badge badge-soft-danger font-size-12">Facturado</div>
                                                                        : null
                                                                    }
                                                                    {item.action === DELIVERY || item.action === DELIVERY_AND_INVOICE ?
                                                                        <div className="badge badge-soft-success font-size-12">Entregado</div>
                                                                        : null
                                                                    }
                                                                    {item.action === CANCELED ?
                                                                        <div className="badge badge-soft-warning font-size-12">Anulado</div>
                                                                        : null
                                                                    }
                                                                </td>
                                                                <td>
                                                                    <Button onClick={() => this.downloadPdfs(item.lots, item.id_user)}>
                                                                        <i className="mdi mdi-printer"></i>
                                                                    </Button>
                                                                    {
                                                                        item.action !== CANCELED ?
                                                                            <Button className="delete-delivery" onClick={() => this._cancelDelivery(item.id, item.action)}>
                                                                                <i className="mdi mdi-close"></i>
                                                                            </Button> : null
                                                                    }
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                </tbody>
                                            </Table>
                                        </div>
                                        <PaginationCustom page={this.state.page} pages={this.state.pages}
                                            onPrev={this.onPrev} onNext={this.onNext} onPage={this.onPage} />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div >
        );
    }
}

const mapStateToProps = (state) => ({
    sessionProps: state.userReducer
});

const mapDispatchToProps = (dispatch) => {
    return {
        logout: () => {
            dispatch(logoutAction());
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DeliverList);